import { type LineItemMessage, sameDate } from "./common";
import { type LineItemBuilder } from "./LineItemUpdate";
import { getIsContractAvailable } from "~/features/productDetails/redux/productDetailsSelectors";
import type { ContractDetailsResponse } from "~/features/contracts/models/models";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

const MSG_CONTRACT_INACTIVE: LineItemMessage = {
  type: "fatal",
  key: "cartPage.error.regular.contractExpired",
};
const MSG_CONTRACT_INACTIVE_DIFFERENT_ACTIVE: LineItemMessage = {
  type: "fatal",
  key: "cartPage.error.regular.contractExpiredDifferentActive",
};

export function refreshContractDetailsLoad(
  lineItem: LineItemBuilder,
  productDescriptor: ProductDescriptor,
  contractDetails: ContractDetailsResponse,
): void {
  const isThisContractActive = validateContractIsActive(contractDetails);
  const isSomeContractActive = validateSomeContractIsActive(productDescriptor);

  if (isThisContractActive) {
    refreshFromContract(lineItem, contractDetails);
    return;
  }

  if (isSomeContractActive === null) {
    console.warn("Could not refresh contract details load - missing P data");
  }

  lineItem.removeMessage(MSG_CONTRACT_INACTIVE_DIFFERENT_ACTIVE.key);
  lineItem.removeMessage(MSG_CONTRACT_INACTIVE.key);

  lineItem.addMessage(isSomeContractActive ? MSG_CONTRACT_INACTIVE_DIFFERENT_ACTIVE : MSG_CONTRACT_INACTIVE);
}

function validateContractIsActive(contractDetails?: ContractDetailsResponse) {
  return !!contractDetails;
}

function validateSomeContractIsActive(productDescriptor: ProductDescriptor) {
  if (!productDescriptor.isLoaded) {
    return null;
  }
  return getIsContractAvailable(productDescriptor);
}

function refreshFromContract(lineItem: LineItemBuilder, contractDetails: ContractDetailsResponse): void {
  if (!sameDate(lineItem.get("minRdd"), contractDetails.contractValidFrom)) {
    lineItem.set("minRdd", contractDetails.contractValidFrom);
  }
  if (!sameDate(lineItem.get("maxRdd"), contractDetails.contractValidTo)) {
    lineItem.set("maxRdd", contractDetails.contractValidTo);
  }
}
